import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { RemoveSubscriptionBalance } from "../../services/PackageLog/PackageLog";
import { InputText } from "primereact/inputtext";
import { putStoreCustomerAccountTransaction } from "../../services/StoreCustomerAccount/postStoreCustomerAccountTransaction";

const WalletAmountEditModal = ({
  walletAmountEditModalVisible,
  setWalletAmountEditModalVisible,
  walletAmountEditSelectedItem,
  sendDataToWalletAmountEdit,
  storeLocalData,
  brandId,
  storeCustomerId,
  storeUserId,
  storeId,
}) => {
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const [amountValue, setAmountValue] = useState("");
  const [remarkValue, setRemarkValue] = useState("");

  const handleAmountChange = (text) => {
    setAmountValue(text);
  };

  const handleRemarkChange = (text) => {
    setRemarkValue(text);
  };

  useEffect(() => {
    setAmountValue(walletAmountEditSelectedItem?.payment?.amount ?? "");
    setRemarkValue(walletAmountEditSelectedItem?.payment?.paymentRefNo ?? "");
  }, [walletAmountEditSelectedItem]);

  const handleConfirmation = () => {
    setIsSubmitButtonPressed(true);

    const data = {
      ...walletAmountEditSelectedItem,
      payment: {
        ...walletAmountEditSelectedItem.payment,
        paymentRefNo: remarkValue,
        amount: amountValue,
      },
    };

    putStoreCustomerAccountTransaction(storeCustomerId, storeId, data)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          if (res.status === true) {
            sendDataToWalletAmountEdit({
              success: res.status,
              message: res.message,
            });
            setIsSubmitButtonPressed(false);
            setWalletAmountEditModalVisible(false);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    sendDataToWalletAmountEdit({
      success: false,
    });
    setWalletAmountEditModalVisible(!walletAmountEditModalVisible);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={walletAmountEditModalVisible}
        style={{ width: "40vw" }}
        onHide={() => {
          if (!walletAmountEditModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column  "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Wallet Amount Edit
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div className="flex-auto mt-2 mx-4">
              <InputText
                value={amountValue}
                onChange={(e) => handleAmountChange(e.target.value)}
                keyboardType="numeric"
                placeholder="Edit Balance *"
                className="w-full text-xl border-round-xl shadow-2"
              />
            </div>

            <div className="flex-auto mt-2 mx-4">
              <InputText
                value={remarkValue}
                onChange={(e) => handleRemarkChange(e.target.value)}
                placeholder="Reference No./ Remark"
                className="w-full text-xl border-round-xl shadow-2"
              />
            </div>

            <div className="flex flex-1 mt-2">
              <Button
                onClick={handleConfirmation}
                disabled={isSubmitButtonPressed}
                className="flex-1 mt-1 mb-3 mx-4 p-1 border-round-xl "
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Submit
                </p>
              </Button>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default WalletAmountEditModal;
